import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { useRecipeModule } from "../hooks/useRecipeModule";
import { RecipeModuleText } from "../utils/RecipeModule-Types";
import { AllRecipesSlider } from "./AllRecipesSlider";
import { ProgramMealsSliders } from "./ProgramMealsSliders";
import { RecipeModuleSkeleton } from "./RecipeModuleSkeleton";
export const Recipe = ({ sequenceNumber }) => {
    const { mealSelectionStatus, moduleConfig, noMealsText, programMealsWithRecipes, recipeAutoSelection, recipeFetchStatus, renderAllRecipesSlider, selectedDay, showNoMealsText, recipeHandlerProps_One, } = useRecipeModule(sequenceNumber);
    if (recipeFetchStatus === null || recipeFetchStatus === void 0 ? void 0 : recipeFetchStatus.error) {
        return _jsx(Typography, { children: RecipeModuleText.UnexpectedErrorText });
    }
    const showSkeleton = (recipeAutoSelection && (!(mealSelectionStatus === null || mealSelectionStatus === void 0 ? void 0 : mealSelectionStatus.completed) || !(recipeFetchStatus === null || recipeFetchStatus === void 0 ? void 0 : recipeFetchStatus.completed))) ||
        (!recipeAutoSelection && !(recipeFetchStatus === null || recipeFetchStatus === void 0 ? void 0 : recipeFetchStatus.completed));
    if (showSkeleton) {
        return _jsx(RecipeModuleSkeleton, {});
    }
    if (!selectedDay) {
        return _jsx(Typography, { children: moduleConfig.NoDaysAvailableMessage });
    }
    if (showNoMealsText) {
        return _jsx(Typography, Object.assign({ align: "center" }, { children: noMealsText }));
    }
    // Render all recipes in one slider if recipes aren't grouped by meal.
    const DISPLAY_COMPONENT = renderAllRecipesSlider ? AllRecipesSlider : ProgramMealsSliders;
    return (_jsx(DISPLAY_COMPONENT, { programMealsWithRecipes: programMealsWithRecipes, renderAllRecipesSlider: renderAllRecipesSlider, sequenceNumber: sequenceNumber, recipeHandlerProps_One: recipeHandlerProps_One }));
};
